import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { Suspense, lazy, useContext, useMemo } from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '../utils/webpack/chunkRetry';
import { LoadableComponentContext } from '@wix/da-hooks/pkg/useLoadableComponent';
/** Builds a lazy loaded editor component that calls a callback when loading finishes. */ const EditorLoaderFactory = (cb)=>/*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "editor", webpackPrefetch: true */ '../DaEditorWrapper/DaEditorWrapper.container').then((result)=>{
                cb();
                return result;
            })));
/**
 * A context dependent version of our LoadableDaEditorWrapper.
 *
 * Usage:
 * ```jsx
 * // ButtonThatTriggersLoad would use `useContext(LoadableComponentContext)` under the hood.
 * <LoadableComponentContextProvider>
 *    <ButtonThatTriggersLoad />
 *    <LoadableDaEditorWrapper {...} />
 * </LoadableComponentContextProvider>
 * ```
 */ export const LoadableDaEditorWrapper = (_param)=>{
    var { loadingComponent: LoadingComponent } = _param, rest = _object_without_properties(_param, [
        "loadingComponent"
    ]);
    const { isLoadingTriggered, finishLoading } = useContext(LoadableComponentContext);
    const Editor = useMemo(()=>EditorLoaderFactory(finishLoading), [
        finishLoading
    ]);
    if (!isLoadingTriggered) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "LoadableDaEditorWrapper"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(LoadingComponent, null)
    }, /*#__PURE__*/ React.createElement(Editor, rest)));
};
LoadableDaEditorWrapper.displayName = 'LoadableDaEditorWrapper';
export default LoadableDaEditorWrapper;

//# sourceMappingURL=LoadableDaEditorWrapper.js.map